import { render, staticRenderFns } from "./copy-btn.vue?vue&type=template&id=6d4126e4&scoped=true&"
import script from "./copy-btn.vue?vue&type=script&lang=ts&"
export * from "./copy-btn.vue?vue&type=script&lang=ts&"
import style0 from "./copy-btn.vue?vue&type=style&index=0&id=6d4126e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4126e4",
  null
  
)

export default component.exports